import { render, staticRenderFns } from "./RatingSkeleton.vue?vue&type=template&id=5a6d2ece"
import script from "./RatingSkeleton.vue?vue&type=script&lang=ts"
export * from "./RatingSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports